import {Component} from '@angular/core';
import {NavParams, LoadingController} from "ionic-angular";
import {HomePage} from "../home/home";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
    templateUrl: 'feedback.html',
    selector: 'feedback'
})
export class FeedbackPage {
    title: string = "Góp Ý";
    trustedUrl: any;
    loading: any;

    constructor(private navParams: NavParams, private sanitizer: DomSanitizer, public loadingCtrl: LoadingController) {
        let url = 'https://docs.google.com/forms/d/e/1FAIpQLSchQFyeFXRnc9t1RnYasSV1le9SvzSmHxWLoWDrkd4W83FwOg/viewform?entry.1171301224=Tài+khoản: '+HomePage.loginname+'%0A%0A%0A%0A';
        this.loading = loadingCtrl.create({
            content: ''
        });
        this.loading.present();
        this.trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    webLoad(event) {
        this.loading.dismiss().catch(() => {
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/feedback/feedback.ts